<!--
 * @Description: 机构列表页面
 * @Author: wanqian, gaohc
 * @Date: 2022-03-16 16:43:52
-->
<template>
   <div class="body">
    <el-row class="bk-search" style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="6" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 205px" v-model="filterParams.institutionId" filterable clearable 
          placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
            commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="6" style="text-align: left">
        <span class="search-title">所属地区：</span>
        <el-cascader size="small" style="width: 205px" v-model="areaOptions" clearable filterable  
          placeholder="请输入/选择" :options="provinceList" 
          :props="{checkStrictly: true, expandTrigger: 'hover', children: 'subRegionList', label: 'name', value: 'id',}">
        </el-cascader>
      </el-col>
      <el-col :span="6" style="text-align: left">
        <span class="search-title">启用状态：</span>
        <el-select size="small" style="width: 205px" v-model="filterParams.status" clearable filterable 
          placeholder="请输入/选择" :disabled="!statusSelectAble">
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.value" :value="item.key" />
        </el-select>
      </el-col>
      <el-col  :span="4" style="text-align:right">
        <el-button size="small" @click="handleInstQuery" type="primary" icon="el-icon-search" style="width: 80px;">
          搜 索
        </el-button>
        <el-button v-if="dataPvgList.includes('INST_1_CREATE')" size="small" @click="handleAddInstitution" 
          type="primary" icon="el-icon-plus" style="width: 80px;">
          新 增
        </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 20px 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable" 
      header-cell-class-name="table-header-color" row-key="id" :default-sort = "{prop: 'regTime', order: 'descending'}">
        <el-table-column label="机构logo" min-width="7%" align="left">
          <template slot-scope="scope">
            <el-image :src="scope.row.logoPath" fit="cover" class="inst-logo"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="identifier" label="机构编号" min-width="10%" align="left"></el-table-column>
        <el-table-column prop="name" label="机构名称" min-width="12%" align="left"></el-table-column>
        <el-table-column label="所在地区" min-width="12%" align="left">
          <template slot-scope="scope">
            {{scope.row.province ? (scope.row.province + '/') : '-'}}
            {{scope.row.city ? (scope.row.city + '/') : '-'}}
            {{scope.row.county ? scope.row.county : ''}}
          </template>
        </el-table-column>
        <el-table-column label="签约医院" min-width="8%" align="left">
          <template slot-scope="scope">{{scope.row.numOfContractedHospital}}家</template>
        </el-table-column>
        <el-table-column label="钱账通会员" min-width="9%" align="left" v-if="showMember">
          <template slot-scope="scope">
            <!-- merchantStatus是否开通钱账通会员：0-未开通 1-已开通 2-已申请	 -->
            <el-popover v-if="scope.row.memberStatus == 0" placement="bottom" width="166" trigger="hover">
              <div slot="reference">
                <div class="mouse-pointer" style="display: flex; align-items: center;">
                  <span>{{scope.row.memberStatusText}}</span>
                  <el-image :src="require('@/assets/instmng/instlist/img-instmng-merchant.png')" fit="cover" 
                    style="width: 18px; height: 18px; margin-left: 6px;">
                  </el-image>
                </div>
              </div>
              <span style="font-size: 14px; color: #666666; line-height: 20px;">
                点击
                <span style="color: #3A7FF3;font-weight: 500;" class="mouse-pointer" 
                  @click="handlelklMerchantApply(scope.row)">
                  申请开通
                </span>
                钱账通会员
              </span>
            </el-popover>
            <span v-else>{{scope.row.memberStatusText}}</span>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" min-width="7%" align="left">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" active-color="#13ce66" :active-value="1" :inactive-value="0" 
              :disabled="scope.row.type == typeReserve || !dataPvgList.includes('INST_3_STATUS_CHG')" 
              @change="handleStatusSwitch(scope.$index, scope.row.status, scope.row.id)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="regTime" label="创建时间" sortable min-width="13%" align="left">
          <template slot-scope="scope">{{dateFormat(scope.row.regTime)}}</template>
        </el-table-column>
        <el-table-column prop="createrName" label="创建人" min-width="8%" align="left"></el-table-column>
        <el-table-column label="操作" min-width="14%" align="left">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">详情</el-button>
            <template v-if="scope.row.type && scope.row.type != typeReserve && dataPvgList.includes('INST_2_UPDATE')">
              <el-divider direction="vertical"></el-divider>
              <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            </template>
            <template v-if="scope.row.type && scope.row.type != typeReserve">
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <el-button type="text" size="small">更多</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleJumpHopspital(scope.$index, scope.row)">签约医院</el-dropdown-item>
                  <el-dropdown-item @click.native="handleJumpHsvc(scope.$index, scope.row)">服务项目</el-dropdown-item>
                  <el-dropdown-item @click.native="handleJumpMeber(scope.$index, scope.row)">人员管理</el-dropdown-item>
                  <el-dropdown-item @click.native="handleJumpBkUser(scope.$index, scope.row)">管理员</el-dropdown-item>
                  <el-dropdown-item v-if="dataPvgList.includes('INST_4_SHARING_RATIO_CHG')"
                    @click.native="handleSetIncome(scope.row)">参数设置</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
        layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
    </el-row>
    <!-- 机构详情对话框 -->
    <institution-details :visible="showInstitutionDialog" :mode="dialogMode" :instid="instId" 
      @close-dialog="closeInstitutionDialog" />

    <!-- 机构收入设置弹窗 -->
    <income-setup-dialog :visible="showIncomeSetupDlg" 
      @close-dialog="showIncomeSetupDlg = false" :instId="instId" 
      :instOpenLkl="instOpenLkl">
    </income-setup-dialog>

    <!-- 申请钱账通商户抽屉 -->
    <mch-apply-drawer :visible="showMchApplyDrawer" :currentInstData="currentInstData"
      @close-drawer="closeMchApplyDrawer" :mode="'add'" />
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import InstitutionDetails from './components/InstitutionDetails.vue'
import IncomeSetup from './components/IncomeSetup.vue'
import MchApplyDrawer from '../memmng/components/ApplyMember.vue'

export default {
  name: 'InstitutionList',

  components: {
    'institution-details': InstitutionDetails,
    'income-setup-dialog': IncomeSetup,
    'mch-apply-drawer': MchApplyDrawer
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      
      areaOptions: [],
      provinceList: [],
      srcInstitutionList: [],
      institutionList: [],
      statusList: [],

      dataTable: [],
      totalNumber: 0,

      //以下用于新增/修改机构对话框使用
      showInstitutionDialog: false,
      dialogMode: '',
      instId: 0,//当前选中机构ID

      typeReserve: 9,//机构类型type为9是系统保留的机构不允许修改

      // 以下用于申请钱账通商户抽屉
      mchId : '',//指定商户的id
      showMchApplyDrawer: false,
      currentInstData: {},//当前选择申请的机构数据

      //以下是分账设置dialog涉及变量
      showIncomeSetupDlg: false,
      instOpenLkl: false,

      showMember: false    //是否显示提现账户列
    }
  },

  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },

    statusSelectAble() {
      return this.dataPvgList.includes('INST_3_STATUS_CHG');
    },
  },
  
  methods:{
    async initData() {
        await this.getDataPvg4CurRole();
        await this.getFilterDo();
        await this.listInstitutions();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'INST'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    async refreshData() {
      await this.getFilterDo();
      await this.listInstitutions();
    },

    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_INSTITUTION_FILTERDO).then(result => {
          if (result != null) {
            this.initFilterData(result.data);
            resolve();
          }
        })
      })
    },

    initFilterData(filterObj) {
      this.institutionList = filterObj.institutionList;
      this.srcInstitutionList = filterObj.institutionList;
      this.statusList = this.commonUtil.map2List(filterObj.statusMap);
      this.provinceList = filterObj.provinceList;
      this.showMember = filterObj.showMember;
      if (this.$route.params.institutionId) {
        this.$set(this.filterParams, 'institutionId', this.$route.params.institutionId)
      } else if (this.globalData.adminType == 2) {
        this.$set(this.filterParams, 'institutionId', this.institutionList[0].id);
      }
    },

    listInstitutions() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_INSTITUTIONS,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.rebulidInstututionsList(result.data);
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },

    rebulidInstututionsList(list) {
      this.dataTable = [];
      //组合图片URL
      list.forEach(item => {
        let current = item;
        current.logoPath = (!item.logoPath || item.logoPath.length == 0)
          ? require('@/assets/instmng/instlist/img-instmng-default.png') 
          : this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE,item.logoPath);
        this.dataTable.push(current);
      });
    },

    handleInstQuery() {
      this.filterParams.page = 1;
      if (this.areaOptions.length > 0) {
        this.filterParams.provinceId = this.areaOptions[0] ? this.areaOptions[0] : "";
        this.filterParams.cityId = this.areaOptions[1] ? this.areaOptions[1] : "";
        this.filterParams.countyId = this.areaOptions[2] ? this.areaOptions[2] : "";
      } else {
        this.filterParams.provinceId = "";
        this.filterParams.cityId = "";
        this.filterParams.countyId = "";
      }
      this.listInstitutions();
    },

    //新增机构
    handleAddInstitution() {
      this.showInstitutionDialog = true;
      this.dialogMode = "add";
      this.instId = 0;
    },

    //详情
    handleDetailClick(item) {
      this.showInstitutionDialog = true;
      this.dialogMode = 'details';
      this.instId = item.id;
    },

    //编辑
    handleEdit(item) {
      this.showInstitutionDialog = true;
      this.dialogMode = 'edit';
      this.instId = item.id;
    },

    //启用状态改变
    handleStatusSwitch(index, val, instId) {
      let item = this.dataTable[index];
      item.status = val == 1 ? 0 : 1;
      let status = val == 1 ? "enable" : "disable";
      let strMessage = val == 1 ? '确认是否启用？' : '确认是否停用？';
      this.$confirm(strMessage, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.queryStatusChange(instId, status);
      });
    },

    queryStatusChange(instId, status) {
      let params = {
        instId: instId,
        status: status
      };
      let header = this.encryptionUtil.signatureParams(params, 
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT', 
        url: Constant.URL_UPDATE_INSTITUTION_STATUS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(_result => {
        this.listInstitutions();
      });
    },

    handlelklMerchantApply(item) {
      this.showMchApplyDrawer = true;
      this.currentInstData = item;
      this.instId = item.id;
    },

    closeMchApplyDrawer(_data) {
      this.listInstitutions();
      this.showMchApplyDrawer = false;
    },

    //跳转签约医院
    handleJumpHopspital(_index, item) {
      this.jumpAsidePage('/hspmng/hsplist', 'hsplist', item.id);
    },

    //跳转服务项目
    handleJumpHsvc(_index, item) {
      this.jumpAsidePage('/hsvcmng/hsvclist', 'hsvclist', item.id);
    },

    //跳转人员管理
    handleJumpMeber(_index, item) {
      this.jumpAsidePage('/instmng/atdnlist', 'atdnlist', item.id);
    },

    //跳转管理员
    handleJumpBkUser(_index, item) {
      this.jumpAsidePage('/usermng/bkuser', 'bkuser', item.id);
    },

    handleSetIncome(item) {
      this.instId = item.id;
      this.instOpenLkl = item.memberStatus;
      this.showIncomeSetupDlg = true;
    },

    //关闭机构对话框
    closeInstitutionDialog(refresh, instId) {
      this.showInstitutionDialog = false;
      //筛选条件中的所属地区是列表项有哪些地区就返回，所以新增成功后需要重新请求过滤Do
      if (refresh) this.refreshData();
      if (this.dialogMode == 'add' && refresh) this.showAddBkUserAlert(instId);
    },

    showAddBkUserAlert(instId) {
      this.$confirm('机构信息保存成功，快去设置机构管理员吧~', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'success'
      }).then(() => {
        this.jumpAsidePage('/usermng/bkuser', 'bkuser', instId, 'instAdd');
      });
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listInstitutions();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listInstitutions();
    },

    //跳转左边aside页面
    jumpAsidePage(_url, name, id, type) {
      if (type) {
        this.$router.push({name: name, params: {institutionId: id, type: type}});
      }else {
        this.$router.push({name: name, params: {institutionId: id}});
      }
    },

    dateFormat(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '机构管理', text2: '机构列表'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.search-title {
  color: #657180;
  font-size: 14px;
}
.main-line {
  height: 10px;
  background-color: #f2f3f4;
}
.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}
.inst-logo {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/InstitutionList.vue